<template>

  <div class="form-control w-full">
    <form @submit.prevent="submitform">

      <label class="label">
        <span class="label-text">Model name:</span>
        <span class="label-text-alt">(field is optional)</span>
      </label>

      <input type="text" class="input input-bordered w-full" name="model" v-model="formdata.model" autocomplete="off" placeholder="ex: Pixel 6" />


      <label class="label">
        <span class="label-text">Brand:</span>
        <span class="label-text-alt">(i.e. Samsung, Apple, Nokia,.... Optional)</span>
      </label>

      <select id="brand_pick" name="brand_pick" v-model="formdata.brand_pick" v-if="posts && posts.length" class="select select-bordered w-full">
        <option value="Null" selected><b>Pick device brand...</b></option>
        <option v-for="post of posts" :key="post" :value="post">{{post}}</option>
      </select>

      <label class="label">
        <span class="label-text">Not in list above? Type it here:</span>
      </label>

      <input type="text" class="input input-bordered w-full" name="brand_explicit" v-model="formdata.brand_explicit" placeholder="for ex: Samsung" autocomplete="off" />

      <label class="label">
        <span class="label-text">Add (up to 5) filters:</span>
        <button class="btn btn-primary text-sm" color="primary" @click="addFilter()" type="button">+</button>
      </label>


      <div v-for="(filter, counter) in filters" :key="counter" class="bg-gray-100">
        <div class="clearfix">
          Filter: #{{counter+1}}
          <span class="remove" @click="deleteFilter(counter)">[X]</span>
        </div>

        <input
            type="text"
            class="input input-bordered max-w-xs"
            v-model="filter.capaname"
            @input="onChange(counter)"
            @keydown.down="onArrowDown(counter)"
            @keydown.up="onArrowUp(counter)"
            @keydown.enter="onEnter(counter)"
            placeholder="Capability"
          />
          <ul v-show="filter.isAutoCompleteOpen" class="menu bg-base-100 w-56 rounded-box">
            <li
              v-for="(result, i) in filter.results"
              :key="i"
              @click="setResult(result, counter)"
              :class="cssActive(counter,i)"
              class="list-none text-left cursor-pointer active:bg-violet-700 hover:bg-violet-600 hover:text-white w-full p-2">{{ result }}</li>
          </ul>
          <br/>
          <select class="select select-bordered" v-model="filter.queryType">
              <option v-for="(typeEntry,j) in legalQueryTypes(counter)" :key="j" :value="typeEntry">{{typeEntry}}</option>
          </select>

          <input type="text"
            class="input input-bordered valid:text-green-400 invalid:text-red-400"
            :pattern="filter.capaPattern"
            :placeholder="filter.patternPlaceholder"
            v-model.lazy="filter.targetvalue" />

      </div>

      <progress v-show="retrieveStatus == 'loading'" class="progress w-12 p-2 wf"></progress>

      <div class="flex flex-wrap items-start justify-between">
        <div class="inline py-2">
            <button class="btn btn-danger" @click.stop="resetform()" type="button">Reset</button>
        </div>
        <div class="inline py-2">
            <button class="btn btn-primary" color="primary" @click.stop="submitform()" type="button"><b>Find Devices</b></button>
        </div>
      </div>

    </form>


    <ul v-if="this.errors && this.errors.length">
      <li v-for="error of this.errors" :key="error">
       {{error}}
      </li>
    </ul>
  </div>

</template>

<script>
import axios from 'axios'

import {useUiElements} from "./../store/uiElements"
import { mapState, mapActions } from 'pinia'


// partition list of capas. Needed to optimize selection of QueryType (i.e. avoid that user
// can select QueryType that makes no sense in a filter based on capability)
// If we let users define illogic queries, WURFL Query API would throw exceptions and those
// are not pretty to handle in a web app. Better to avoid giving users enough rope to hang themselves.
const isBrandList = ['brand_name'];

const isModelCapaList = ['model_name','marketing_name'];

const isSpecialHandlingCapaList = ['brand_name','model_name','marketing_name','release_date',
                                'advertised_device_os_version','advertised_browser_version',
                                'mobile_browser_version','device_os_version'];

const isNumericCapaList = ['colors','max_data_rate','max_image_height',
             'max_image_width','physical_screen_height','physical_screen_width',
             'release_msrp','resolution_height','resolution_width'];

// const isCanRepeatCapaList = ['release_date',
//         'advertised_device_os_version',
//         'advertised_browser_version',
//         'mobile_browser_version',
//         'device_os_version'];


export default {
  name: 'SelectBrandAndModel',
  // props: ['baseUrl'], // DELETE. Now handled by Pinia uiElements

  data() {
    return {
      qrUrl: '',
      // showModal: false,
      posts: [],
      // deviceList: {}, moved to Pinia store
      retrieveStatus: '', // display spinner anim when busy retrieving data from server
      formdata: {
          brand_pick: 'Null',
          brand_explicit: '',
          model: ''
          // marketing: '',
      },

      filters:[]
    }
  },

  mounted() {
    // console.log("onmounted triggered,", this.realBaseUrl)
    // related to Autocomplete function. Need to capture clicks outside of component to close it
    // Really necessary? adding for now...
    document.addEventListener('click', this.handleClickOutside)
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside)
  },


  computed: {
    ...mapState(useUiElements, {
        realBaseUrl: "realBaseUrl",
        auth: "baseRestApiAuth",
        deviceList: "deviceList",
        selectedDevice: "selectedDevice",
        availableCapabilities: "availableCapabilities",
        errors: "errors"
    })

  },

  // Fetches posts when the component is created.
  created() {
    this.resetHTTPErrors();
    axios.get(`${this.realBaseUrl}/v1/brands/findByDeviceCount/20`,
        {auth: this.auth})
      .then(response => {
        // JSON responses are automatically parsed.
        this.posts = response.data.sort()
      })
      .catch(err => {
        console.log("Logging server ERROR: " + err)
        this.setHTTPErrorMessage(err)
      })
  },


  methods: {

    ...mapActions(useUiElements, [
      'setCurrentDeviceList',
      'setAvailableCapabilities',
      'setModalAlert',
      'setHTTPErrorMessage',
      'resetHTTPErrors'
      ]),


    submitform() {
      this.resetHTTPErrors()

      let allFilters = []

      // handling fieds as filters
      if (this.formdata.brand_pick != "Null") {
        console.log("brand_pick is Null")
        let brandFilter = {
                capability_name: "brand_name",
                operator: "Equal",
                capability_value: this.formdata.brand_pick
              }
        allFilters.push(brandFilter)
      } else {

        if (this.formdata.brand_explicit) {
          console.log("brand_explicit is NOT Null: " + this.formdata.brand_explicit)

          let brandFilter = {
                  capability_name: "brand_name",
                  operator: "Equal",
                  capability_value: this.formdata.brand_explicit
                }
          allFilters.push(brandFilter)
        }
      }

      // Model
      if (this.formdata.model) {
        console.log("model field is NOT Null")
        let modelFilter = {
                capability_name: "model_name",
                operator: "NearlyEqual",
                capability_value: this.formdata.model
              }
        allFilters.push(modelFilter)
      }

      // finally the filters that user may have added manually
      this.filters.forEach((filter) => {

        if (filter.capaname.trim() && filter.targetvalue.trim()) {
          allFilters.push({
                capability_name: filter.capaname,
                operator: filter.queryType,
                capability_value: filter.targetvalue
                })
        }
      })

      // signal that we are waiting for data to be retrieved from server
      this.retrieveStatus = 'loading';
      axios({
        method: 'post',
        url: `${this.realBaseUrl}/v1/devices/search`,
        auth: this.auth,
        data: allFilters
      })
      .then(res => {

        this.setCurrentDeviceList(res.data);
        this.retrieveStatus = ''
      })
      .catch(err => {
          // error. To be honest we could improve usability by making the error message a modal.
          console.log("Logging server ERROR: " + err + " - " + err.response.data)
          this.retrieveStatus = ''
          this.setHTTPErrorMessage(err)
          this.setHTTPErrorMessage(err.response.data)
      })
    },


    resetform() {

      let AUSureMsg = "You are also resetting all filters. Are you sure?"
      if (this.filters.length > 0 && ! confirm(AUSureMsg)) {
        return
      }
      this.resetHTTPErrors()

      this.formdata.brand_pick = 'Null'
      this.formdata.brand_explicit = ''
      this.formdata.model = ''

      // also clean filters
      this.filters = []
    },


    addFilter(){

      if (this.filters.length >= 5) {
        // alert("You can only define up to 5 filters. Sorry!");
        //this.$emit("showModal","You can only define up to 5 filters. Sorry!")
        this.setModalAlert("You can only define up to 5 filters. Sorry!")
        return;
      }
      this.filters.push({
        capaname:'',
        queryType: 'Equal',
        targetvalue: '',

        //capability type. Needed to select right set of choices for queryType
        capaType: 'general',
        // capability pattern (and placeholder).
        // RegExp to help with capability format (release_date and numeric)
        capaPattern: ".*",
        patternPlaceholder: 'Target value',
        // needed for capability name autocomplete function
        // inspired by:  https://www.digitalocean.com/community/tutorials/vuejs-vue-autocomplete-component
        results: [],
        isAutoCompleteOpen: false,
        arrowCounter: -1,
      })
    },
    deleteFilter(counter){
      // in case you want to know what splice does:
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice?retiredLocale=it
      this.filters.splice(counter,1);
    },

    // AUTOCOMPLETE methods
    // inspired by this (V2!) example: https://www.digitalocean.com/community/tutorials/vuejs-vue-autocomplete-component
    onChange(counter) {

      let item = this.filters[counter];
      // don't trigger autocomplete unless you have at least two chars
      // console.log("capa field " + counter + " : " + this.filters[counter].capaname.length)
      if (this.filters[counter].capaname.length < 2) {
        return;
      }

      item.results = this.availableCapabilities.filter(capastring => capastring.toLowerCase().indexOf(item.capaname.toLowerCase()) > -1);
      item.isAutoCompleteOpen = true;
    },

    setResult(pick, counter) {
      let item = this.filters[counter];
      item.capaname = pick;
      item.capaType = this.getCapabilityType(pick);
      item.isAutoCompleteOpen = false;
      item.capaType = this.getCapabilityType(item.capaname);
      item.capaPattern = this.getCapabilityPattern(item.capaname);
      item.patternPlaceholder = this.getCapabilityPlaceHolderPattern(item.capaname);
    },

    // Autocomplete Filters: arrow key navigation

    onArrowDown(counter) {
      let item = this.filters[counter];
      if (item.arrowCounter < item.results.length -1) {
        item.arrowCounter = item.arrowCounter + 1;
      } else {
        item.arrowCounter = 0;
      }
    },

    onArrowUp(counter) {
      let item = this.filters[counter];
      if (item.arrowCounter > 0) {
        item.arrowCounter = item.arrowCounter - 1;
      } else {
        item.arrowCounter = item.results.length - 1;
      }
    },

    onEnter(counter) {
      let item = this.filters[counter];
      if (item.arrowCounter > -1) {
        item.capaname = item.results[item.arrowCounter];
        console.log("arrowCounter is: " + item.results[item.arrowCounter]);
      } else {
        console.log("Weird arrowCounter is: " + item.arrowCounter);
      }
      item.isAutoCompleteOpen = false;
      item.arrowCounter = -1;
      item.capaType = this.getCapabilityType(item.capaname);
      item.capaPattern = this.getCapabilityPattern(item.capaname);
      item.patternPlaceholder = this.getCapabilityPlaceHolderPattern(item.capaname);
    },

    // set color of currently selected autocomplete during arrow key navigation
    cssActive(counter, i) {
      let item = this.filters[counter];
      if (i == item.arrowCounter) {
        return "bg-violet-700 text-white";
      }
    },

    // Set QueryType selection
    getCapabilityType(capaname) {

      if (isBrandList.includes(capaname)) { return "brand";}
      if (isModelCapaList.includes(capaname)) { return "model";}
      if (isSpecialHandlingCapaList.includes(capaname)) { return "special";}
      if (isNumericCapaList.includes(capaname)) { return "numeric";}

      return "general";

      // if (isCanRepeatCapaList.includes(capaname)) { return "repeat";}

    },

    // Set pattern on input type depending on capability
    getCapabilityPattern(capaname) {

      // release_date has a very specific syntax for accepted values
      if (capaname === "release_date") { return "[\\d]{4}_[a-z]+";}


      // let's support boolean, why not
      if (capaname.startsWith("is_")) { return "true|false";}

      // Numeric? only consider numbers as OK values
      if (isNumericCapaList.includes(capaname)) { return "\\d+";}

      // ' and " are NOT OK
      return ".*";
    },


    // Set pattern on input type depending on capability
    getCapabilityPlaceHolderPattern(capaname) {

      if (capaname === "release_date") { return "ex: 2020_january";}

      // let's support boolean, why not
      if (capaname.startsWith("is_")) { return "true or false";}

      if (isNumericCapaList.includes(capaname)) { return "ex: 123456";}

      return "Target value";
    },

    legalQueryTypes(filterIndex) {

      let qt = this.filters[filterIndex].capaType; // qt = queryType
      if (qt == 'general') {
        return ['Equal','NotEqual'];
      }

      if (qt == 'special' || qt == 'numeric') {
        return ['Equal','NotEqual','LessThan','GreaterThan','EqualOrLessThan','EqualOrGreaterThan'];
      }

      if (qt == 'model') {
        return ['Equal','NotEqual','LessThan', 'CaseInsensitiveEqual','NearlyEqual','Contains'];
      }

      // Brand
      return ['Equal','NotEqual', 'CaseInsensitiveEqual'];
    },


    // invoked by document.addEventListener(click)
    handleClickOutside() {

      // tempted to remove these 3 lines. In case one day you need to understand where the click hit...
      // add (event) as a parameter to the handler in that case
      // if (!this.$el.contains(event.target)) {
      //    console.log(this.$el);
      // }
      this.filters.map(item => item.isAutoCompleteOpen = false);
      this.filters.map(item => item.arrowCounter = -1);

    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

span.remove {
  width: 30px;
  float: right;
  cursor: pointer;
  text-decoration: underline;
}
span.remove:hover{
  color: brown;
}

/* For autocomplete:-moz-any: https://www.digitalocean.com/community/tutorials/vuejs-vue-autocomplete-component  */
/*
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  height: 120px;
  min-height: 1em;
  max-height: 6em;
  overflow: visible;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}

.autocomplete-result.is-active, .autocomplete-result:hover {
  background-color: #4AAE9B;
  color: white;
} */

/* form validation */
/* .targetValue:valid {
    color: green;
}
.targetValue:invalid {
    color: red;
} */

</style>

<!-- style scoped>
div.myform {
  border: 10px;
}
input {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #422c50;
  margin-top: 6px;
}
</style -->